var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"inner"},[_vm._m(0),_c('div',{staticClass:"right"},[_c('span',[_c('router-link',{attrs:{"to":"/policy"}},[_vm._v("Privacy policy")])],1),_c('span',[_c('router-link',{attrs:{"to":"/terms"}},[_vm._v("Terms of use")])],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left"},[_c('span',{staticClass:"a"},[_vm._v("© 2024 Koloma Family. All rights reserved.")])])
}]

export { render, staticRenderFns }